<pcg-table [ajaxData]='{ userId: id }' [multipleSearch]='false' [pcgSort]='[[ "dateAttempted", "desc" ]]'
	dataSource='api/Administration/Users/GetLoginHistoryList' [columnDefs]='columns' [canExactMatchSearch]="false">

	<ng-container cdkColumnDef="dateAttempted">
		<th cdk-header-cell pcg-sort-header *cdkHeaderCellDef>{{ columns.get('dateAttempted').displayName }}</th>
		<td cdk-cell *cdkCellDef='let row' data-label="Date Attempted">{{ row.dateAttemptedFormatted }}</td>
	</ng-container>

	<ng-container cdkColumnDef="attemptSuccessful">
		<th cdk-header-cell pcg-sort-header *cdkHeaderCellDef>{{ columns.get('attemptSuccessful').displayName }}</th>
		<td cdk-cell *cdkCellDef='let row' data-label="Attempt Successful?">{{ row.attemptSuccessful }}</td>
	</ng-container>

	<ng-container cdkColumnDef="userName">
		<th cdk-header-cell pcg-sort-header *cdkHeaderCellDef>{{ columns.get('userName').displayName }}</th>
		<td cdk-cell *cdkCellDef='let row' data-label="Username">{{ row.userName }}</td>
	</ng-container>

	<ng-container cdkColumnDef="ipAddress">
		<th cdk-header-cell pcg-sort-header *cdkHeaderCellDef>{{ columns.get('ipAddress').displayName }}</th>
		<td cdk-cell *cdkCellDef='let row' data-label="IP Address">{{ row.ipAddress }}</td>
	</ng-container>
	
</pcg-table>
